import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ActivateAccount } from './activate-account.model';

export const loadActivateAccounts = createAction(
  '[ActivateAccount/API] Load ActivateAccounts',
  props<{ activateAccounts: ActivateAccount[] }>()
);

export const addActivateAccount = createAction(
  '[ActivateAccount/API] Add ActivateAccount',
  props<{ activateAccount: ActivateAccount }>()
);

export const upsertActivateAccount = createAction(
  '[ActivateAccount/API] Upsert ActivateAccount',
  props<{ activateAccount: ActivateAccount }>()
);

export const addActivateAccounts = createAction(
  '[ActivateAccount/API] Add ActivateAccounts',
  props<{ activateAccounts: ActivateAccount[] }>()
);

export const upsertActivateAccounts = createAction(
  '[ActivateAccount/API] Upsert ActivateAccounts',
  props<{ activateAccounts: ActivateAccount[] }>()
);

export const updateActivateAccount = createAction(
  '[ActivateAccount/API] Update ActivateAccount',
  props<{ activateAccount: Update<ActivateAccount> }>()
);

export const updateActivateAccounts = createAction(
  '[ActivateAccount/API] Update ActivateAccounts',
  props<{ activateAccounts: Update<ActivateAccount>[] }>()
);

export const deleteActivateAccount = createAction(
  '[ActivateAccount/API] Delete ActivateAccount',
  props<{ id: string }>()
);

export const deleteActivateAccounts = createAction(
  '[ActivateAccount/API] Delete ActivateAccounts',
  props<{ ids: string[] }>()
);

export const clearActivateAccounts = createAction(
  '[ActivateAccount/API] Clear ActivateAccounts'
);

//Custom actions
export const activateAccount = createAction(
  '[ActivateAccount/API] Activate Account',
  props<{ input?: {
      password?: string;
      token?: string;
    } }>()
)
